import { IOrder } from "~/graphql/queries/order/orderByNumberAndPostalCode";

export const shipmentIdsFromOrder = (order: IOrder | null) => {
  if (!order || !order.orderItems) {
    return [];
  }
  return order.orderItems
    .map(
      orderItem =>
        (orderItem.supplierOrder && orderItem.supplierOrder.trackingCode) ||
        orderItem.trackingNumber
    )
    .filter(trackingCode => trackingCode);
};



// WEBPACK FOOTER //
// ./src/helpers/shipmentIdsFromOrder.ts